import { useMemo } from "react";

export function Sparkles({ count = 34 }) {
  const stars = useMemo(
    () =>
      Array.from({ length: count }, () => {
        const bronze = Math.random() < 0.3;
        return {
          left: Math.random() * 100,
          top: Math.random() * 100,
          size: 7 + Math.random() * 13,
          delay: Math.random() * 10,
          dur: 2.8 + Math.random() * 3.6,
          color: bronze ? "#8A5A0F" : "#FFFFFF",
          glow: bronze ? "rgba(138,90,15,0.8)" : "rgba(255,255,255,0.9)",
          max: 0.75 + Math.random() * 0.25,
        };
      }),
    [count]
  );

  return (
    <div className="sparkle-layer" aria-hidden="true" data-testid="sparkle-layer">
      {stars.map((s, i) => (
        <span
          key={i}
          className="sparkle-star"
          style={{
            left: `${s.left}%`,
            top: `${s.top}%`,
            width: s.size,
            height: s.size,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.dur}s`,
            "--tw-max": s.max,
          }}
        >
          <svg viewBox="0 0 24 24" fill={s.color} style={{ filter: `drop-shadow(0 0 ${s.size / 2}px ${s.glow})` }}>
            <path d="M12 0 L14.6 9.4 L24 12 L14.6 14.6 L12 24 L9.4 14.6 L0 12 L9.4 9.4 Z" />
          </svg>
        </span>
      ))}
    </div>
  );
}
